export default __webpack_public_path__ + "static/media/rocket_anim_45.a093d81c.png";